export { default } from './MainLayout'


// WEBPACK FOOTER //
// ./src/components/Layout/MainLayout/index.js